export default __webpack_public_path__ + "static/media/promo_05.fcb388a2.jpg";